<template>
    <div id="payerContractUploadModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5" id="payerContractUploadTitle">Upload Payer Contract File</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body text-center">
                    <div class="form-group mb-3">
                        <input type="text" class="form-control form-control-sm" placeholder="Description" v-model="description">
                    </div>
                    <div class="d-flex justify-content-center mb-3">
                        <div class="w-25">
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control text-right" min="0" max="100" step="5" pattern="[1-9]{3}" v-model="rate">
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                        <div class="font-small ml-1 pt-1">of Louisiana Workers' Compensation Fee Schedule.</div>
                    </div>                                                                                                  
                    <form method="post" action="#" files="true" enctype="multipart/form-data" id="attachments-dropzone" class="dropzone"> 
                        <input type="hidden" name="_token" :value="csrf">             
                        <input type="hidden" name="client_id" :value="clientId">
                    </form>
                    <div class="text-muted font-small font-italic text-left">NOTE: Contract file must be in PDF format.</div>                     
                </div>                        
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    props: {
        clientId: Number
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            callback: null,
            description: '',
            rate: 100,
        }
    },
    methods: {
        show: function(callback) {

            this.callback = callback;
            this.description = '';
            this.rate = 100;  
            $('#payerContractUploadModal').modal('show');
        }   
    },
    created() {
        var self = this;
        eventHub.$on('show-payer-contract-upload', self.show);

        Dropzone.options.attachmentsDropzone = {
            url: '/ajax/provider/clients/' + self.clientId + '/payercontract',
            maxFilesize: 100, // files 100MB or less this matches php.ini
            addRemoveLinks: true,
            timeout: 15000,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            thumbnailHeight: 32,
            acceptedFiles: "application/pdf",
            init: function() {
                this.on('sending', function(file, xhr, formData) {
                    formData.append('description', self.description);
                    formData.append('rate', self.rate);
                });
                this.on('complete', function(file) {
                    this.removeAllFiles(true);
                    $('#payerContractUploadModal').modal('hide');                                        
                });
            },
            success(files, response) {
                self.callback();
            },
            error(file, response) {
                let message = response.message ? response.message : response;
                toastr['error'](message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            }        
        };    
    },
    beforeDestroy() {
        eventHub.$off('show-payer-contract-upload');
    }       
}
</script>

<style scoped>
    .w-95 {
        width: 95% !important;
    }

    .font-small {
        font-size: .97em;
    }      
</style>